import { jsx as _jsx } from "react/jsx-runtime";
export function Boolean({ value, ...other }) {
    return (_jsx("div", { ...other, children: value !== undefined ? (value ? '✔' : '✘') : '' }));
}
//# sourceMappingURL=Boolean.js.map